import * as signalR from '@microsoft/signalr'
import store from '@/store'
import { log } from '@/utils/logger'

const lang = localStorage.getItem('lang') || 'pl-PL'

const createConnection = (url) => {
  return new signalR.HubConnectionBuilder()
    .withUrl(url, {
      accessTokenFactory: () => localStorage.getItem('token')
    })
    .withAutomaticReconnect()
    .build()
}

// Backend confirmed SpediLinkHub endpoint.
const spedilinkConnection = createConnection(`${process.env.VUE_APP_BASE}spedilinkHub?Language=${lang}`)
const freightConnection = createConnection(`${process.env.VUE_APP_BASE}freightHub?Language=${lang}`)
const vehicleConnection = createConnection(`${process.env.VUE_APP_BASE}vehicleHub?Language=${lang}`)

const registerSpedilinkListeners = () => {
  spedilinkConnection.on('ListAdded', async (linkData) => {
    log('SPEDILINKHUB - ListAdded', linkData)
    await store.dispatch('spedilink/onListAdded', linkData)
  })

  spedilinkConnection.on('ListRemoved', async (linkId) => {
    log('SPEDILINKHUB - ListRemoved', linkId)
    await store.dispatch('spedilink/onListRemoved', linkId)
  })

  // Backend may emit NewInterest when someone expresses interest in an order.
  // Payload is expected to be compatible with SpediLinkInterestVm.
  spedilinkConnection.on('NewInterest', async (interest) => {
    log('SPEDILINKHUB - NewInterest', interest)
    await store.dispatch('spedilink/onNewInterest', interest)
  })

  spedilinkConnection.on('NewOffersRead', async (data) => {
    log('SPEDILINKHUB - NewOffersRead', data)
    await store.dispatch('spedilink/onNewOffersRead', data)
  })

  spedilinkConnection.on('InterestsRead', async (data) => {
    log('SPEDILINKHUB - InterestsRead', data)
    await store.dispatch('spedilink/onInterestsRead', data)
  })
}

const registerOrderListeners = (connection, orderType) => {
  connection.on('LinkOrderAdded', async (linkId, orderViewModel) => {
    log(`ORDERHUB - LinkOrderAdded (${orderType})`, linkId, orderViewModel)
    await store.dispatch('spedilink/onLinkOrderAdded', { linkId, orderViewModel, orderType })
  })

  connection.on('LinkOrderModified', async (linkId, orderViewModel) => {
    log(`ORDERHUB - LinkOrderModified (${orderType})`, linkId, orderViewModel)
    await store.dispatch('spedilink/onLinkOrderModified', { linkId, orderViewModel, orderType })
  })

  connection.on('LinkOrderRemoved', async (linkId, orderId) => {
    log(`ORDERHUB - LinkOrderRemoved (${orderType})`, linkId, orderId)
    await store.dispatch('spedilink/onLinkOrderRemoved', { linkId, orderId, orderType })
  })
}

registerSpedilinkListeners()
registerOrderListeners(freightConnection, 'freight')
registerOrderListeners(vehicleConnection, 'vehicle')

export const spedilinkStart = async () => {
  try {
    // Dedicated connections are intentional: List events come from SpediLinkHub,
    // order events come from Freight/Vehicle hubs and must work for guest too.
    await Promise.all([
      spedilinkConnection.start(),
      freightConnection.start(),
      vehicleConnection.start()
    ])
  } catch (e) {
    console.error(e.toString())
  }
}

export const spedilinkStop = async () => {
  try {
    await Promise.all([
      spedilinkConnection.stop(),
      freightConnection.stop(),
      vehicleConnection.stop()
    ])
  } catch (e) {
    console.error(e.toString())
  }
}
